import React from 'react';
import './UnderConstructionBar.css';

const UnderConstructionBar = () => (
    <div className="UnderConstructionBar">
        <span className="UnderConstructionBar-text">Under construction!</span>
    </div>
);

export default UnderConstructionBar;



// WEBPACK FOOTER //
// ./src/components/UnderConstruction/UnderConstructionBar.jsx